import {
  FETCH_GEOFENCE_REQUEST,
  FETCH_GEOFENCE_SUCCESS,
  FETCH_GEOFENCE_FAILURE,
  DELETE_GEOFENCE_REQUEST,
  DELETE_GEOFENCE_SUCCESS,
  DELETE_GEOFENCE_FAILURE,
} from "../actions/parkGeofenceActions";

const initialState = {
  geofenceList: [],
  loading: false,
  error: null,
  deleteLoading: false,
  deleteSuccess: false,
};

export default function geofenceReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GEOFENCE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_GEOFENCE_SUCCESS:
      return { ...state, loading: false, geofenceList: action.payload };
    case FETCH_GEOFENCE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_GEOFENCE_REQUEST:
      return { ...state, deleteLoading: true, deleteSuccess: false };
    case DELETE_GEOFENCE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteSuccess: true,
        // remove deleted item from list
        geofenceList: state.geofenceList.filter((g) => g.id !== action.payload.id),
      };
    case DELETE_GEOFENCE_FAILURE:
      return { ...state, deleteLoading: false, error: action.payload };

    default:
      return state;
  }
}
